module.exports = __webpack_public_path__ + "img/FZ.d32d6fa4.png";